<template>
  <div>
      <b-table
        class="table b-table"
        :items="items"
        :fields="fields"
      >
        <template #cell(ver_detalles)="{}">
          <b-button
            variant="ligth"
            @click="$router.push(
              { name: 'files',
               params: { view: 'general' },
               query: { filters: `febosId:${ file.febosId}` }
              }
            )"
          >
            <font-awesome-icon :icon="['fas', 'info-circle']"/>
          </b-button>
        </template>
        <template #cell(estado)="{ item }">
          <span>{{fileStates.find(s => s.id === item.estado).value}}</span>
        </template>
      </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'FileExpedientView',
  data() {
    return {
      fields: [
        {
          key: 'numero',
          label: 'Número'
        },
        {
          key: 'creado_por',
          label: 'Creado por'
        },
        {
          key: 'estado',
          label: 'Estado'
        },
        {
          key: 'fecha_creacion',
          label: 'Fecha creación'
        },
        {
          key: 'resumen',
          label: 'Resumen'
        },
        {
          key: 'tipo_doc',
          label: 'Tipo doc'
        },
        {
          key: 'ver_detalles',
          label: 'Ver detalles'
        }
      ],
      fileStates: [
        { id: 1, value: 'Creado' },
        { id: 2, value: 'Ingresado' },
        { id: 3, value: 'Borrador' },
        { id: 5, value: 'Rechazado' },
        { id: 6, value: 'En flujo' },
        { id: 8, value: 'Anulado' },
        { id: 9, value: 'Finalizado' },
        { id: 10, value: 'Tramitado' },
        { id: 12, value: 'Aprobado' },
        { id: 100, value: 'Archivado' },
        { id: 101, value: 'Descartado' }
      ],
    };
  },
  props: {
    file: {
      required: true
    }
  },
  methods: {
    ...mapActions('DocManagement', [
      'loadApprovals',
    ]),
    async getApprovals() {
      const params = {
        orden: encodeURIComponent('-fechaCreacion'),
        filtros: `documentoId:${this.getSelectedElement.id}`,
        itemsPorPagina: 500,
        pagina: 1,
      };
      await this.loadApprovals(params);
    }
  },
  computed: {
    ...mapGetters('DocManagement', [
      'getSelectedElement',
      'approvals'
    ]),
    items() {
      return [{
        numero: this.file.numero,
        creado_por: this.file.solicitanteNombre,
        estado: this.file.estado,
        fecha_creacion: this.file.fechaCreacion,
        resumen: this.file.nombreDescriptivo,
        tipo_doc: this.file.emisorSucursalDireccion,
        ver_detalles: this.file.febosId,
      }];
    },
  }
};
</script>

<style>

</style>
